import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { t } from 'src/lib/language';
import { BASE_URL } from 'src/environments/environment';
import { getSubscriptionAction } from 'src/redux/actions/subscriptionActions';

interface OwnProps {
  subscriptionId: number;
}

type Props = OwnProps & ButtonProps;

const ShowPaymentsForSubscriptionButton = (props: Props) => {
  const { disabled, subscriptionId } = props;
  const lang = useSelector((state: Store) => state.language.language);
  const dispatch = useAppDispatch();

  const onClick = () => {
    if (!subscriptionId) return;
    dispatch(getSubscriptionAction(subscriptionId));
    window.open(`${BASE_URL}/payments/subscription/${subscriptionId}`);
  };

  return (
    <Tooltip
      title={t(lang, 'menus.show_subscription_payments')}
      placement="top-start">
      <span>
        <ActionButton
          data-testid="show-payments-subscription-button"
          category={MENU_BUTTON_CATEGORY.presets}
          onClick={onClick}
          disabled={disabled}>
          <DescriptionOutlinedIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default ShowPaymentsForSubscriptionButton;
